// These values correspond to the ids of the EntityTypes table.
export enum ElementTargetsEnum {
  HierarchyElements = 1,
  NetworkElements = 2,
}
